import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box, Button, CircularProgress } from "@mui/material";
import { Print, ArrowBack } from "@mui/icons-material";
import api from "../../api/axiosInstance";

const AdminDeliveryReceiptPrint = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [html, setHtml] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api
            .get(`/delivery-receipts/${id}/render`)
            .then(({ data }) => setHtml(data.data.html))
            .finally(() => setLoading(false));
    }, [id]);

    if (loading) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
                <CircularProgress />
            </Box>
        );
    }
    if (!html) return null;

    return (
        <Box>
            <Box className="no-print" sx={{ display: "flex", gap: 1, mb: 2 }}>
                <Button startIcon={<ArrowBack />} variant="outlined" size="small" onClick={() => navigate(-1)}>
                    Back
                </Button>
                <Button startIcon={<Print />} variant="contained" size="small" onClick={() => window.print()}>
                    Print
                </Button>
            </Box>

            {/* Always white page / dark text — this is a document meant to be
                printed on paper, never a dark-mode surface, and the
                server-generated HTML assumes a white backdrop of its own. */}
            <Box
                sx={{ maxWidth: 700, mx: "auto", bgcolor: "#fff", color: "#0E1420", p: 2 }}
                dangerouslySetInnerHTML={{ __html: html }}
            />

            <style>{`
        @media print {
          .no-print { display: none !important; }
          body { margin: 0; }
        }
      `}</style>
        </Box>
    );
};

export default AdminDeliveryReceiptPrint;